export const REMOVE_PRODUCT_MSG = (value: string) =>
  `Tem certeza que deseja excluir o produto "${value}"? Ao confirmar essa ação não é possível reverter.`;

export const REMOVE_PRODUCT_SUCCESS = 'Produto removido com sucesso';
export const REMOVE_PRODUCT_ERROR = 'Houve uma falha ao remover o produto';
